import { ApiCore } from "./utilities/core";

const url = 'process_mining/coverage_statistics';

const apiGenerateBpmnModel = new ApiCore({
  getAll: false,
  getSingle: false,
  post: false,
  postSingle: true,
  put: false,
  patch: true,
  delete: false,
  url: url,
});

export default apiGenerateBpmnModel;